/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { GetPlayerDetails200ResponseCardLevelMatrixInner } from './GetPlayerDetails200ResponseCardLevelMatrixInner';
import {
    GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSON,
    GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSONTyped,
    GetPlayerDetails200ResponseCardLevelMatrixInnerToJSON,
    instanceOfGetPlayerDetails200ResponseCardLevelMatrixInner,
} from './GetPlayerDetails200ResponseCardLevelMatrixInner';

/**
 * 
 * @export
 * @interface GetPlayerDetails200Response
 */
export interface GetPlayerDetails200Response {
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    playerNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cardNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    preferredName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    tier?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    tierLock?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    addressOne?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    addressTwo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    postcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    employee?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    gender?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    okToMail?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    okToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    okToText?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    okToCall?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    gamingMarketingOptIn?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    nonGamingMarketingOptIn?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    memberSince?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    birthday?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    birthdayDoubleAvailable?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    birthdayDoubleActive?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    anniversary?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    driversLicense?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pin?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    currentLocation?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    todaysPoints?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    todaysBonusPoints?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pointBalance?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    compbalance?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    fbhBalance?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    nonCashBalance?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    nonCashAvailable?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pointDollars?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    entries?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    globalEntries?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    lastActivity?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    inactive?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    playerType?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    emailAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    preferences?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    comments?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cellNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    host?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cdsHex?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cdsAcc?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cdsPID?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    trend?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    downloadsEnabled?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    idType?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    idExpires?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    infPoolFBHPromo?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    secondAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    secondCity?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    secondState?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    secondPostcode?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    secondCountry?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    sundayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    mondayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    tuesdayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    wednesdayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    thursdayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    fridayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    saturdayVisits?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pasDistribution?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pasLastViewedDate?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    useCardLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cardLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    lockCardLevel?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    cardLevelPrintName?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPlayerDetails200Response
     */
    pcsoffered?: string;
    /**
     * 
     * @type {Array<GetPlayerDetails200ResponseCardLevelMatrixInner>}
     * @memberof GetPlayerDetails200Response
     */
    cardLevelMatrix?: Array<GetPlayerDetails200ResponseCardLevelMatrixInner>;
    /**
     * Points remaining to reach the next card level. Null if already at the highest level or card levels are not in use.
     * @type {number}
     * @memberof GetPlayerDetails200Response
     */
    pointsToNextLevel?: number | null;
}


/**
 * Check if a given object implements the GetPlayerDetails200Response interface.
 */
export function instanceOfGetPlayerDetails200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetPlayerDetails200ResponseFromJSON(json: any): GetPlayerDetails200Response {
    return GetPlayerDetails200ResponseFromJSONTyped(json, false);
}

export function GetPlayerDetails200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPlayerDetails200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'playerNumber': !exists(json, 'playerNumber') ? undefined : json['playerNumber'],
        'cardNumber': !exists(json, 'cardNumber') ? undefined : json['cardNumber'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'preferredName': !exists(json, 'preferredName') ? undefined : json['preferredName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'tier': !exists(json, 'tier') ? undefined : json['tier'],
        'tierLock': !exists(json, 'tierLock') ? undefined : json['tierLock'],
        'addressOne': !exists(json, 'addressOne') ? undefined : json['addressOne'],
        'addressTwo': !exists(json, 'addressTwo') ? undefined : json['addressTwo'],
        'city': !exists(json, 'city') ? undefined : json['city'],
        'state': !exists(json, 'state') ? undefined : json['state'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'postcode': !exists(json, 'postcode') ? undefined : json['postcode'],
        'employee': !exists(json, 'employee') ? undefined : json['employee'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'okToMail': !exists(json, 'okToMail') ? undefined : json['okToMail'],
        'okToEmail': !exists(json, 'okToEmail') ? undefined : json['okToEmail'],
        'okToText': !exists(json, 'okToText') ? undefined : json['okToText'],
        'okToCall': !exists(json, 'okToCall') ? undefined : json['okToCall'],
        'gamingMarketingOptIn': !exists(json, 'gamingMarketingOptIn') ? undefined : json['gamingMarketingOptIn'],
        'nonGamingMarketingOptIn': !exists(json, 'nonGamingMarketingOptIn') ? undefined : json['nonGamingMarketingOptIn'],
        'memberSince': !exists(json, 'memberSince') ? undefined : json['memberSince'],
        'birthday': !exists(json, 'birthday') ? undefined : json['birthday'],
        'birthdayDoubleAvailable': !exists(json, 'birthdayDoubleAvailable') ? undefined : json['birthdayDoubleAvailable'],
        'birthdayDoubleActive': !exists(json, 'birthdayDoubleActive') ? undefined : json['birthdayDoubleActive'],
        'anniversary': !exists(json, 'anniversary') ? undefined : json['anniversary'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'driversLicense': !exists(json, 'driversLicense') ? undefined : json['driversLicense'],
        'pin': !exists(json, 'pin') ? undefined : json['pin'],
        'currentLocation': !exists(json, 'currentLocation') ? undefined : json['currentLocation'],
        'todaysPoints': !exists(json, 'todaysPoints') ? undefined : json['todaysPoints'],
        'todaysBonusPoints': !exists(json, 'todaysBonusPoints') ? undefined : json['todaysBonusPoints'],
        'pointBalance': !exists(json, 'pointBalance') ? undefined : json['pointBalance'],
        'compbalance': !exists(json, 'compbalance') ? undefined : json['compbalance'],
        'fbhBalance': !exists(json, 'fbhBalance') ? undefined : json['fbhBalance'],
        'nonCashBalance': !exists(json, 'nonCashBalance') ? undefined : json['nonCashBalance'],
        'nonCashAvailable': !exists(json, 'nonCashAvailable') ? undefined : json['nonCashAvailable'],
        'pointDollars': !exists(json, 'pointDollars') ? undefined : json['pointDollars'],
        'entries': !exists(json, 'entries') ? undefined : json['entries'],
        'globalEntries': !exists(json, 'globalEntries') ? undefined : json['globalEntries'],
        'lastActivity': !exists(json, 'lastActivity') ? undefined : json['lastActivity'],
        'inactive': !exists(json, 'inactive') ? undefined : json['inactive'],
        'playerType': !exists(json, 'playerType') ? undefined : json['playerType'],
        'emailAddress': !exists(json, 'emailAddress') ? undefined : json['emailAddress'],
        'preferences': !exists(json, 'preferences') ? undefined : json['preferences'],
        'comments': !exists(json, 'comments') ? undefined : json['comments'],
        'cellNumber': !exists(json, 'cellNumber') ? undefined : json['cellNumber'],
        'host': !exists(json, 'host') ? undefined : json['host'],
        'cdsHex': !exists(json, 'cdsHex') ? undefined : json['cdsHex'],
        'cdsAcc': !exists(json, 'cdsAcc') ? undefined : json['cdsAcc'],
        'cdsPID': !exists(json, 'cdsPID') ? undefined : json['cdsPID'],
        'trend': !exists(json, 'trend') ? undefined : json['trend'],
        'downloadsEnabled': !exists(json, 'downloadsEnabled') ? undefined : json['downloadsEnabled'],
        'idType': !exists(json, 'idType') ? undefined : json['idType'],
        'idExpires': !exists(json, 'idExpires') ? undefined : json['idExpires'],
        'infPoolFBHPromo': !exists(json, 'infPoolFBHPromo') ? undefined : json['infPoolFBHPromo'],
        'secondAddress': !exists(json, 'secondAddress') ? undefined : json['secondAddress'],
        'secondCity': !exists(json, 'secondCity') ? undefined : json['secondCity'],
        'secondState': !exists(json, 'secondState') ? undefined : json['secondState'],
        'secondPostcode': !exists(json, 'secondPostcode') ? undefined : json['secondPostcode'],
        'secondCountry': !exists(json, 'secondCountry') ? undefined : json['secondCountry'],
        'sundayVisits': !exists(json, 'sundayVisits') ? undefined : json['sundayVisits'],
        'mondayVisits': !exists(json, 'mondayVisits') ? undefined : json['mondayVisits'],
        'tuesdayVisits': !exists(json, 'tuesdayVisits') ? undefined : json['tuesdayVisits'],
        'wednesdayVisits': !exists(json, 'wednesdayVisits') ? undefined : json['wednesdayVisits'],
        'thursdayVisits': !exists(json, 'thursdayVisits') ? undefined : json['thursdayVisits'],
        'fridayVisits': !exists(json, 'fridayVisits') ? undefined : json['fridayVisits'],
        'saturdayVisits': !exists(json, 'saturdayVisits') ? undefined : json['saturdayVisits'],
        'pasDistribution': !exists(json, 'pasDistribution') ? undefined : json['pasDistribution'],
        'pasLastViewedDate': !exists(json, 'pasLastViewedDate') ? undefined : json['pasLastViewedDate'],
        'useCardLevel': !exists(json, 'useCardLevel') ? undefined : json['useCardLevel'],
        'cardLevel': !exists(json, 'cardLevel') ? undefined : json['cardLevel'],
        'lockCardLevel': !exists(json, 'lockCardLevel') ? undefined : json['lockCardLevel'],
        'cardLevelPrintName': !exists(json, 'cardLevelPrintName') ? undefined : json['cardLevelPrintName'],
        'pcsoffered': !exists(json, 'pcsoffered') ? undefined : json['pcsoffered'],
        'cardLevelMatrix': !exists(json, 'cardLevelMatrix') ? undefined : ((json['cardLevelMatrix'] as Array<any>).map(GetPlayerDetails200ResponseCardLevelMatrixInnerFromJSON)),
        'pointsToNextLevel': !exists(json, 'pointsToNextLevel') ? undefined : json['pointsToNextLevel'] === null ? null : json['pointsToNextLevel'],
    };
}

export function GetPlayerDetails200ResponseToJSON(value?: GetPlayerDetails200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'playerNumber': value.playerNumber,
        'cardNumber': value.cardNumber,
        'title': value.title,
        'firstName': value.firstName,
        'preferredName': value.preferredName,
        'lastName': value.lastName,
        'tier': value.tier,
        'tierLock': value.tierLock,
        'addressOne': value.addressOne,
        'addressTwo': value.addressTwo,
        'city': value.city,
        'state': value.state,
        'country': value.country,
        'postcode': value.postcode,
        'employee': value.employee,
        'gender': value.gender,
        'okToMail': value.okToMail,
        'okToEmail': value.okToEmail,
        'okToText': value.okToText,
        'okToCall': value.okToCall,
        'gamingMarketingOptIn': value.gamingMarketingOptIn,
        'nonGamingMarketingOptIn': value.nonGamingMarketingOptIn,
        'memberSince': value.memberSince,
        'birthday': value.birthday,
        'birthdayDoubleAvailable': value.birthdayDoubleAvailable,
        'birthdayDoubleActive': value.birthdayDoubleActive,
        'anniversary': value.anniversary,
        'ssn': value.ssn,
        'phoneNumber': value.phoneNumber,
        'driversLicense': value.driversLicense,
        'pin': value.pin,
        'currentLocation': value.currentLocation,
        'todaysPoints': value.todaysPoints,
        'todaysBonusPoints': value.todaysBonusPoints,
        'pointBalance': value.pointBalance,
        'compbalance': value.compbalance,
        'fbhBalance': value.fbhBalance,
        'nonCashBalance': value.nonCashBalance,
        'nonCashAvailable': value.nonCashAvailable,
        'pointDollars': value.pointDollars,
        'entries': value.entries,
        'globalEntries': value.globalEntries,
        'lastActivity': value.lastActivity,
        'inactive': value.inactive,
        'playerType': value.playerType,
        'emailAddress': value.emailAddress,
        'preferences': value.preferences,
        'comments': value.comments,
        'cellNumber': value.cellNumber,
        'host': value.host,
        'cdsHex': value.cdsHex,
        'cdsAcc': value.cdsAcc,
        'cdsPID': value.cdsPID,
        'trend': value.trend,
        'downloadsEnabled': value.downloadsEnabled,
        'idType': value.idType,
        'idExpires': value.idExpires,
        'infPoolFBHPromo': value.infPoolFBHPromo,
        'secondAddress': value.secondAddress,
        'secondCity': value.secondCity,
        'secondState': value.secondState,
        'secondPostcode': value.secondPostcode,
        'secondCountry': value.secondCountry,
        'sundayVisits': value.sundayVisits,
        'mondayVisits': value.mondayVisits,
        'tuesdayVisits': value.tuesdayVisits,
        'wednesdayVisits': value.wednesdayVisits,
        'thursdayVisits': value.thursdayVisits,
        'fridayVisits': value.fridayVisits,
        'saturdayVisits': value.saturdayVisits,
        'pasDistribution': value.pasDistribution,
        'pasLastViewedDate': value.pasLastViewedDate,
        'useCardLevel': value.useCardLevel,
        'cardLevel': value.cardLevel,
        'lockCardLevel': value.lockCardLevel,
        'cardLevelPrintName': value.cardLevelPrintName,
        'pcsoffered': value.pcsoffered,
        'cardLevelMatrix': value.cardLevelMatrix === undefined ? undefined : ((value.cardLevelMatrix as Array<any>).map(GetPlayerDetails200ResponseCardLevelMatrixInnerToJSON)),
        'pointsToNextLevel': value.pointsToNextLevel,
    };
}

